export default "__VITE_ASSET__EhsI$K9HpPAp71ia5XJLxQ__"